import React, { useContext, useEffect, useState } from 'react'
import { Card, Flex, Space, Typography, DatePicker, DatePickerProps } from 'antd'
import AuthContext from '../context/AuthContext'
import { AdminChartData, AdminDataRequest, User } from '../interfaces/AppInterfaces'
import type { Dayjs } from 'dayjs';
import backendApi from '../api/backendApi';
import dayjs from 'dayjs';
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

const DashboardPage = () => {

    const [user, setUser] = useState<User>()
    const [rangeDates, setRangeDates] = useState<string[]>([])
    const [fromDate, setFromDate] = useState<string>()
    const [toDate, setToDate] = useState<string>()
    const [isLoading, setisLoading] = useState<boolean>(true)
    const [roles, setRoles] = useState<number>()
    const [adminUsers, setAdminUsers] = useState<number>()
    const [totalDocs,  setTotalDocs] = useState<number>()
    const [totalTaxes, setTotalTaxes] = useState<number>()
    const [digitalEmiters, setDigitalEmiters] = useState<number>()
    const [totalAnullments, setTotalAnullments] = useState<number>()
    const [massivesDocs, setMassivesDocs] = useState<number>()
    const [totalBackups, setTotalBackups] = useState<number>()
    const [graphData, setGraphData] = useState<AdminChartData[]>()



    const onChangeFrom: DatePickerProps['onChange'] = (date, dateString) => {
        //setisLoading(true)
                
        //@ts-ignore
        setFromDate(dateString);
        if (toDate) {
            //@ts-ignore
            setRangeDates([fromDate,toDate])
        }
        else
        {
            const Date = dayjs();
            const x = Date.add(15, 'day');
            const y = Date.format('YYYY-MM-DD');
            //@ts-ignore
            setRangeDates([fromDate,y])
        }
    };

    const onChangeTo: DatePickerProps['onChange'] = (date, dateString) => {
        //@ts-ignore
        setToDate(dateString);
        if (fromDate) {
            //@ts-ignore
            setRangeDates([fromDate,toDate])
        }
        else
        {
            const Date = dayjs();
            const x = Date.subtract(15, 'day');
            const y = Date.format('YYYY-MM-DD');
            //@ts-ignore
            setRangeDates([fromDate,y])
        }
    };
      

    useEffect(() => {
        const user =  localStorage.getItem('user');
        if (user) {
            setUser(JSON.parse(user));
        }
            const Date = dayjs();
            setFromDate(Date.format('YYYY-MM-DD'))
            const fromDate = Date.subtract(15, 'day');
            const fromDateString = fromDate.format('YYYY-MM-DD');
            setFromDate(fromDateString)
            getDashboardData()
        }, [])
    
    const dateTimeOnChange = (
        date: [any, any] | null,
        dateString: [string, string]
      ): void => {
        setisLoading(true)
        setRangeDates(dateString);
      };
    
    const getDashboardData = async()=>{
        if (rangeDates.length === 2) {
            const getDataRequest =await backendApi.post<AdminDataRequest>('/adminDashboardData',{from_date:rangeDates[0],to_date:rangeDates[1]});
            setAdminUsers(getDataRequest.data.data[0].admin_users)
            setTotalDocs(getDataRequest.data.data[0].total_docs)
            setTotalTaxes(getDataRequest.data.data[0].total_taxes)
            setDigitalEmiters(getDataRequest.data.data[0].digital_emiters)
            setTotalAnullments(getDataRequest.data.data[0].total_anullments)
            setMassivesDocs(getDataRequest.data.data[0].massives_docs)
            setTotalBackups(getDataRequest.data.data[0].total_backups)
            setRoles(getDataRequest.data.data[0].roles)
            setGraphData(getDataRequest.data.data[0].chart_data)
        }
        else
        {
            const toDate = dayjs();
            const toDateString = toDate.format('YYYY-MM-DD');
            const fromDate = toDate.subtract(15, 'day');
            const fromDateString = fromDate.format('YYYY-MM-DD');
            const getDataRequest =await backendApi.post<AdminDataRequest>('/adminDashboardData',{from_date:fromDateString,to_date:toDateString});
            setAdminUsers(getDataRequest.data.data[0].admin_users)
            setTotalDocs(getDataRequest.data.data[0].total_docs)
            setTotalTaxes(getDataRequest.data.data[0].total_taxes)
            setDigitalEmiters(getDataRequest.data.data[0].digital_emiters)
            setTotalAnullments(getDataRequest.data.data[0].total_anullments)
            setMassivesDocs(getDataRequest.data.data[0].massives_docs)
            setTotalBackups(getDataRequest.data.data[0].total_backups)
            setRoles(getDataRequest.data.data[0].roles)
            setGraphData(getDataRequest.data.data[0].chart_data)
        }
        setisLoading(false)
    }
      
    useEffect(() => {
        getDashboardData()
    }, [rangeDates])
    
return (    
    <Flex justify="center" vertical gap="middle">
        <Flex  gap="middle">

            <Flex justify="center" gap="middle" align="center">
                <Typography.Text>Desde: </Typography.Text>
                <DatePicker defaultValue={dayjs().subtract(15, 'day')} onChange={onChangeFrom} />
            </Flex>
            
            <Flex justify="center" gap="middle" align="center">
                <Typography.Text>Hasta: </Typography.Text>
                <DatePicker defaultValue={dayjs().add(15, 'day')} onChange={onChangeTo}/>
            </Flex>
            
        </Flex>
        <Typography.Title>Bienvenido {user?.name}</Typography.Title>      
        
        <Flex gap="middle">
            <Card style={{  width: '25%', backgroundColor:'' }} loading={isLoading}>
                <Flex justify="center" vertical gap="middle" align="center">
                    <Typography style={{fontWeight:'bold', fontSize:16, color:'#8c8c8c'}}>Documentos Enviados</Typography>
                    <Typography style={{fontWeight:'bold', fontSize:30}}>{totalDocs}</Typography>
                </Flex>
            </Card>
            <Card style={{  width: '25%', backgroundColor:'RGB(198, 249, 202, 0.8)'}} loading={isLoading}>
                <Flex justify="center" vertical gap="middle" align="center">
                    <Typography style={{fontWeight:'bold', fontSize:16, color:'#8c8c8c'}}>Usuarios Admin</Typography>
                    <Typography style={{fontWeight:'bold', fontSize:30}}>{adminUsers}</Typography>
                </Flex>
            </Card>
            <Card style={{  width: '25%', backgroundColor:'RGB(198, 249, 250, 0.8)' }} loading={isLoading}>
                <Flex justify="center" vertical gap="middle" align="center">
                    <Typography style={{fontWeight:'bold', fontSize:16, color:'#8c8c8c'}}>Roles</Typography>
                    <Typography style={{fontWeight:'bold', fontSize:30}}>{roles}</Typography>
                </Flex>
            </Card>

            <Card style={{  width: '25%', backgroundColor:'RGB(198, 204, 250, 0.8)' }} loading={isLoading}>
                <Flex justify="center" vertical gap="middle" align="center">
                    <Typography style={{fontWeight:'bold', fontSize:16, color:'#8c8c8c'}}>Cargas Masivas</Typography>
                    <Typography style={{fontWeight:'bold', fontSize:30}}>{massivesDocs}</Typography>
                </Flex>
            </Card>
        </Flex>    
        
        <Flex gap="middle">
            <Card style={{  width: '25%', backgroundColor:'' }} loading={isLoading}>
                <Flex justify="center" vertical gap="middle" align="center">
                    <Typography style={{fontWeight:'bold', fontSize:16, color:'#8c8c8c'}}>Documentos Anulados</Typography>
                    <Typography style={{fontWeight:'bold', fontSize:30}}>{totalAnullments}</Typography>
                </Flex>
            </Card>
            <Card style={{  width: '25%', backgroundColor:'RGB(198, 249, 202, 0.8)'}} loading={isLoading}>
                <Flex justify="center" vertical gap="middle" align="center">
                    <Typography style={{fontWeight:'bold', fontSize:16, color:'#8c8c8c'}}>Emisores Digitales</Typography>
                    <Typography style={{fontWeight:'bold', fontSize:30}}>{digitalEmiters}</Typography>
                </Flex>
            </Card>
            <Card style={{  width: '25%', backgroundColor:'RGB(198, 249, 250, 0.8)' }} loading={isLoading}>
                <Flex justify="center" vertical gap="middle" align="center">
                    <Typography style={{fontWeight:'bold', fontSize:16, color:'#8c8c8c'}}>Impuestos Totales</Typography>
                    <Typography style={{fontWeight:'bold', fontSize:30}}>{totalTaxes} Bs</Typography>
                </Flex>
            </Card>
            <Card style={{  width: '25%', backgroundColor:'RGB(198, 204, 250, 0.8)' }} loading={isLoading}>
                <Flex justify="center" vertical gap="middle" align="center">
                    <Typography style={{fontWeight:'bold', fontSize:16, color:'#8c8c8c'}}>Documentos Respaldados</Typography>
                    <Typography style={{fontWeight:'bold', fontSize:30}}>{totalBackups}</Typography>
                </Flex>
            </Card>
        </Flex>  
        <Flex gap="middle">
            <Card style={{  width: '100%', height:500, backgroundColor:'#ffff' }} loading={isLoading}>
                <ResponsiveContainer width="100%" height={500}>
                    <LineChart
                        width={200}
                        height={300}
                        data={graphData}
                        margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="date" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Line type="monotone" dataKey="billCount" stroke="#3498DB" activeDot={{ r: 8 }} name="Facturas" />
                        <Line type="monotone" dataKey="totalTax" stroke="#E74C3C" name="Total de Impuestos" />
                        <Line type="monotone" dataKey="totalBase" stroke="#F1C40F" name="Total de Base Imponible" />
                        <Line type="monotone" dataKey="creditNoteCount" stroke="#2ECC71" name="Notas de Credito" />
                        <Line type="monotone" dataKey="debitNoteCount" stroke="#9B59B6" name="Notas de Debito" />
                    </LineChart>
                </ResponsiveContainer>
            </Card>
        </Flex>
    </Flex>
)
}

export default DashboardPage
